import { useRef, useState } from "react";
import { CloseIcon } from "../../components/icons/Icon2";
import styles from "../dashboard/Dispatch.module.css";
import Button from "../../components/updatedComponents/Dealers/Button";
import { Close, Printers } from "../../components/icons/Icon";
import { PrintLabel } from "./PrintLabel";
import { useReactToPrint } from "react-to-print";

const PrintLabelModal = ({ mode, closeModal, packs, submit, orderData }) => {
  const [noOfPacks, setNoOfPacks] = useState(packs || 1);

  const labelRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => labelRef.current,
  });

  return (
    <div
      className={styles.pack_order_modal}
      style={{ backgroundColor: mode && "#232529", height: "300px" }}
    >
      <div className={styles.header}>
        <p style={{ color: mode && "#FFFFFF" }}>Print Label</p>
        <div onClick={closeModal}>
          <CloseIcon mode={mode} />
        </div>
      </div>

      <div className={styles.no_of_packs}>
        <p style={{ color: mode && "#FFFFFF" }}>Enter number of pack(s):</p>
        <input
          type="number"
          max={999}
          onInput={(e) => {
            if (e.target.value.length > 3) {
              e.target.value = e.target.value.slice(0, 3);
            }
          }}
          style={{
            backgroundColor: mode && "#1B1D21",
            borderColor: mode && "#1B1D21",
            color: mode && "#9F9F9F",
          }}
          value={noOfPacks}
          onChange={(e) => setNoOfPacks(e.target.value)}
        />
      </div>

      <div style={{ display: "none" }}>
        <PrintLabel
          data={orderData}
          qtyPacks={noOfPacks}
          ref={labelRef}
          handlePrint={handlePrint}
        />
      </div>

      <div style={{ flex: "1" }}></div>

      <div className={styles.bottom_btns}>
        <Button
          buttonBgColor={"#000000"}
          buttonTextColor={"#FFFFFF"}
          buttonText={"Close"}
          buttonIcon={<Close />}
          buttonClick={closeModal}
        />
        <Button
          buttonBgColor={"#4164E3"}
          buttonTextColor={"#FFFFFF"}
          buttonText={"Print"}
          buttonIcon={<Printers color="#FFFFFF" />}
          buttonClick={() => {
            submit(noOfPacks);
            handlePrint();
          }}
        />
      </div>
    </div>
  );
};

export default PrintLabelModal;
